import { pageTabForPath, pageTabPath } from "./page-tab-routes.js";

// One mounted navigation owner. The URL is authoritative; projections never
// write history. Non-tab paths (e.g. fish details) leave the mounted panel alone.
export function createPageTabNavigation({ page, basePath, root, project, window: host = window }) {
  let started = false;
  const selected = () => pageTabForPath(page, basePath, host.location.pathname);
  const restore = () => {
    const tab = selected();
    if (tab !== null) project(tab);
  };
  const navigate = (tab) => {
    const url = new URL(host.location.href);
    url.pathname = pageTabPath(page, basePath, tab);
    if (url.href !== host.location.href) host.history.pushState(null, "", url);
    project(tab);
  };
  const click = (event) => {
    const tab = event.target.closest?.("[data-page-tab]");
    if (!tab || !root.contains(tab) || event.defaultPrevented || event.button > 0
      || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(tab.dataset.pageTab);
  };
  return {
    selected,
    navigate,
    start() {
      if (started) return;
      started = true;
      root.addEventListener("click", click);
      host.addEventListener("popstate", restore);
      restore();
    },
    stop() {
      if (!started) return;
      started = false;
      root.removeEventListener("click", click);
      host.removeEventListener("popstate", restore);
    },
  };
}
